module.exports = __webpack_public_path__ + "static/media/job-post-promo-arrow.fae7ee20.svg";